import React from 'react';
import { productChipsInterface } from 'modules/product/interfaces/product-chips.interface';

interface ProductChipsProps {
    productChips: productChipsInterface;
    component: React.FC<any>;
}

const ProductChips: React.FC<ProductChipsProps> = props => {
    const items = [];

    if (props.productChips.relatedProducts.length > 0) {
        items.push({
            label: 'Powiązane produkty',
            items: props.productChips.relatedProducts
        });
    }

    if (props.productChips.newProducts.length > 0) {
        items.push({
            label: 'Nowości',
            items: props.productChips.newProducts
        });
    }

    if (props.productChips.linkingCategories.length > 0) {
        items.push({
            label: 'Powiązane kategorie',
            items: props.productChips.linkingCategories
        });
    }

    if (props.productChips.popularCategories.length > 0) {
        items.push({
            label: 'Popularne kategorie',
            items: props.productChips.popularCategories
        });
    }

    return <props.component data={items} />;
};

export default ProductChips;
